module.exports = __webpack_public_path__ + "static/img/cs1.43fb849.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/pic/cs1.jpg
// module id = FhOb
// module chunks = 11